import React from 'react'
import ImageSliderBlockSlider from './ImageSliderBlock/ImageSliderBlockSlider'
import ImageSpreadsBlock from './ImageSliderBlock/ImageSpreadsBlock'

const ImageSliderBlock = ({ block }) => {
  if (block.show_slider) {
    return <ImageSliderBlockSlider block={block} />
  } else {
    return <ImageSpreadsBlock block={block} />
  }
}

export default ImageSliderBlock
